import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import fullStackImage from '../../images/cardpageimages/technicalcourse/fullstackwebdevelopment.jpg';
import IntroVideos from "../../componants/introvideos";
import FullStackModule from "../../componants/allCourseModule/TechnicalCourseModule/FullStackModule";

function FullStackWebDevelopment() {
  return (
    <>
      <Header />
      <BannerForAll
        title="FULL STACK WEB DEVELOPMENT FULL COURSE"
        text="Our Full Stack Web Development Full Course offers a comprehensive guide to building modern web applications. Learn front-end development with HTML, CSS, JavaScript, and frameworks like React, along with back-end technologies including Node.js, Express, and MongoDB. This course covers full-stack architecture, API development, database management, and deployment, giving you the skills to become a proficient full-stack developer and build dynamic web applications from start to finish."
        imageone={fullStackImage}
        imagetwo={fullStackImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="FULL STACK WEB DEVELOPMENT"
      />
      <FullStackModule />
      <Footer />
    </>
  );
}

export default FullStackWebDevelopment;
